module.exports = __webpack_public_path__ + "img/buildings-1.1a8e06a2.png";